export const EMAIL_CONFLICT = 'An account with the given email already exists.';
export const USER_IS_NOT_CONFIRMED = 'User is not confirmed.';
export const INCORRECT_CREDENTIALS = 'Incorrect username or password.';
export const USER_NOT_FOUND = 'User not found';
export const USER_INACTIVE = 'UserNotConfirmedOrInactive';
export const INVALID_CODE = 'Invalid verification code provided, please try again.';
export const RECORD_NOT_FOUND = 'Record not found';
